import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useAnonymiseData = () => {
  return usePost({ url: ApiRoutesEnum.anonymiseCandidate });
};
